import { Box, Link, paletteColors, Stack, Typography } from '@evaneos/b2b-ui';

import { Logo } from '../../../design-system/SVG/Logo';

import { DPO_EMAIL, LOGIN_URL, PARTNER_URL, PRIVACY_POLICY_PATH } from '../constants/urls';

const LINK_SX = {
    color: paletteColors.neutral[400],
    '&:hover': { color: paletteColors.neutral[0] },
    display: 'block',
};

const WEBSITES = [
    { label: 'France', href: 'https://www.evaneos.fr/' },
    { label: 'Germany', href: 'https://www.evaneos.de/' },
    { label: 'Spain', href: 'https://www.evaneos.es/' },
    { label: 'Italy', href: 'https://www.evaneos.it/' },
    { label: 'Netherlands', href: 'https://www.evaneos.nl/' },
    { label: 'Switzerland', href: 'https://www.evaneos.ch/' },
];

export const TravelSuiteFooter = () => (
    <Box
        component="footer"
        sx={{
            backgroundColor: paletteColors.green[900],
            color: paletteColors.neutral[0],
            px: { xs: 2, md: 8 },
            py: { xs: 6, md: 8 },
            mt: 'auto',
        }}
    >
        <Box sx={{ maxWidth: '1200px', mx: 'auto' }}>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '2fr 1fr 1fr 1fr' },
                    gap: { xs: 5, md: 6 },
                    mb: 6,
                }}
            >
                <Stack spacing={2}>
                    <Logo color={paletteColors.neutral[0]} />
                    <Typography
                        variant="body2"
                        sx={{ color: paletteColors.neutral[400], lineHeight: 1.6 }}
                    >
                        Evaneos SA
                        <br />
                        27 Rue de Mogador
                        <br />
                        75009 Paris, France
                        <br />
                        Registered in Paris under RCS 513 191 122.
                    </Typography>
                </Stack>

                <Stack spacing={0.5}>
                    <Typography
                        component="h3"
                        variant="subtitle2"
                        fontWeight={700}
                        sx={{ color: paletteColors.neutral[0], mb: 0.5 }}
                    >
                        Travel Suite
                    </Typography>
                    <Link href={LOGIN_URL} variant="body2" sx={LINK_SX} underline="none">
                        Log in
                    </Link>
                    <Link
                        href={PARTNER_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="body2"
                        sx={LINK_SX}
                        underline="none"
                    >
                        Become a partner
                    </Link>
                </Stack>

                <Stack spacing={0.5}>
                    <Typography
                        component="h3"
                        variant="subtitle2"
                        fontWeight={700}
                        sx={{ color: paletteColors.neutral[0], mb: 0.5 }}
                    >
                        Legal
                    </Typography>
                    <Link href={PRIVACY_POLICY_PATH} variant="body2" sx={LINK_SX} underline="none">
                        Privacy Policy
                    </Link>
                    <Link
                        href={`mailto:${DPO_EMAIL}`}
                        variant="body2"
                        sx={LINK_SX}
                        underline="none"
                    >
                        Contact our DPO
                    </Link>
                </Stack>

                <Stack spacing={0.5}>
                    <Typography
                        component="h3"
                        variant="subtitle2"
                        fontWeight={700}
                        sx={{ color: paletteColors.neutral[0], mb: 0.5 }}
                    >
                        Our websites
                    </Typography>
                    {WEBSITES.map(({ label, href }) => (
                        <Link
                            key={label}
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer"
                            variant="body2"
                            sx={LINK_SX}
                            underline="none"
                        >
                            {label}
                        </Link>
                    ))}
                </Stack>
            </Box>

            <Box sx={{ borderTop: `1px solid ${paletteColors.green[800]}`, pt: 3 }}>
                <Typography variant="body2" sx={{ color: paletteColors.neutral[500] }}>
                    © {new Date().getFullYear()} Evaneos SA. All rights reserved.
                </Typography>
            </Box>
        </Box>
    </Box>
);
